import { isNil, isNumber, isBoolean, isFunction, isRegExp, isDate, isEmpty } from "lodash-es"

/**
 * 动态加载脚本(promise)
 * @param srcPath 脚本地址
 * @returns 
 */
export const asyncLoadRemoteScript = (src: string) => {
  return new Promise<boolean>((resolve, reject) => {
    const sid = encodeURIComponent(src)
    const oldScriptEl = document.getElementById(sid)

    if (isNil(oldScriptEl)) {
      const scriptEl = document.createElement('script')
      scriptEl.src = src
      scriptEl.id = sid
      document.body.appendChild(scriptEl)

      scriptEl.onload = () => {
        resolve(true)
      }
      scriptEl.onerror = () => {
        reject(`脚本[${src}]加载失败`)
      }
    } else {
      resolve(false)
    }
  })
}

/**
 * 从sessionStorage中获取appid
 * @returns 
 */
export const getAppId = () => sessionStorage.getItem('appId') || ''

/**
 * 判断数据是否为空
 * @param value 需检测的数据
 * @returns 
 */
export const isBlank = (value: unknown): value is null|undefined  => {
  if (isNil(value)) {
    return true
  }
  if (isNumber(value) || isBoolean(value) || isFunction(value) || 
    isDate(value) || isRegExp(value)) {
    return false
  }
  return isEmpty(value)
}
